import type { RouteLocation } from "vue-router";

import { LANGUAGE_GROUP_ENGLISH, LANGUAGE_GROUPS_PRIORITIZED } from "@/common/language-groups";
import { PACKAGE_GROUPS_PRIORITIZED } from "@/common/package-groups";
import { PACKAGE_GROUP_ORDBOGEN } from "@/common/package-groups-types";
import { ROUTER_PARAM_LANGUAGE, ROUTER_PARAM_PACKAGE_GROUP } from "@/router/router-params";
import { useSettingsStore } from "@/stores";

/** Adds/replaces package and language params in url with currently active. */
export const addPackageAndLangParams = (
  location: Partial<RouteLocation>
): Partial<RouteLocation> => {
  const settingsStore = useSettingsStore();

  return {
    ...location,
    params: {
      ...location.params,
      [ROUTER_PARAM_PACKAGE_GROUP]:
        settingsStore.preferredPackageGroup?.id || PACKAGE_GROUP_ORDBOGEN,
      [ROUTER_PARAM_LANGUAGE]: settingsStore.activeLanguageGroup || LANGUAGE_GROUP_ENGLISH
    }
  };
};

/** Builds route path with package and language in url */
export const buildPackageAndLangPath = (path: string): string => {
  const packageGroupsRegex = PACKAGE_GROUPS_PRIORITIZED.join("|");
  const languagesRegex = LANGUAGE_GROUPS_PRIORITIZED.join("|");
  return `/:${ROUTER_PARAM_PACKAGE_GROUP}(${packageGroupsRegex})/:${ROUTER_PARAM_LANGUAGE}(${languagesRegex})/${path}`;
};
